import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PageSubTitle, Loading } from 'components/common/Elements/Elements';
import TextWidget2 from 'components/common/charts/TextWidget2/TextWidget2';
import Chart from './Chart/Chart';
import { postRequest } from 'utils/requests';

import classes from './Widgets.module.scss';

const Widgets = ({ customerId }) => {
  const [npsCharts, setNpsCharts] = useState({});
  const [loaderChart, setLoaderChart] = useState(true);

  useEffect(() => {
    let cancelled = false;
    postRequest('/customer/satisfaction/nps/widgets', {
      customerId: customerId
    })
      .then(res => {
        if (!cancelled) {
          setNpsCharts(res.body);
          setLoaderChart(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setLoaderChart(false);
        }
      });
    return () => (cancelled = true);
  }, [customerId]);

  const nps = {
    title: 'NPS',
    value: npsCharts.nps && npsCharts.nps.replace('NaN', '0'),
    only90: true
  };

  const npsCalc = {
    title: 'Calculated NPS',
    value: npsCharts.calcNps,
    only90: true
  };

  return (
    <section className={classes.charts}>
      <PageSubTitle hiden title="NPS chart and widgets" size={3} />
      {loaderChart ? (
        <Loading />
      ) : (
        <>
          <div className={classes.widgets}>
            <TextWidget2 data={nps} />
            <TextWidget2 data={npsCalc} />
          </div>
          <Chart data={npsCharts.chartData} />
        </>
      )}
    </section>
  );
};

Widgets.propTypes = {
  customerId: PropTypes.string
};

export default memo(Widgets);
